// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5792ae55] .avue-crud .el-table .el-form-item{margin-bottom:1px!important}.text-red[data-v-5792ae55]{color:#f56c6c}.strong[data-v-5792ae55]{padding:0 0 15px 20px}[data-v-5792ae55] .avue-crud__pagination{position:relative;padding:5px 0 10px 10px;text-align:right}[data-v-5792ae55] .avue-crud__empty{padding:10px 0}", ""]);
// Exports
module.exports = exports;
